import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useLocation } from "react-router-dom";
import Input from "components/Input";
import Button from "components/Button";
import ModalResetPasswordSuccessfully from "screens/ModalResetPasswordSuccessfully";
import { useMutation } from "@apollo/client";
import { COMPLETE_STAFF_SETUP } from "graphql/service";
import { Container, ContentContainer } from "./styles";
import Logo from "assets/Logo.png";
import { HiddenIcon, VisibleIcon } from "assets/icons";
import { debouncedErrorMessage } from "utils/messageUtil";

const SetupPassword = ({ redirectPath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [successIsOpen, setSuccessIsOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordHidden, setPasswordHidden] = useState(true);

  const params = new URLSearchParams(location.search);
  const token = params.get("token");

  const [
    completeStaffSetup,
    { data: setupData, loading: resetPasswordLoading },
  ] = useMutation(COMPLETE_STAFF_SETUP, {
    onCompleted: (setupData) => {
      if (setupData.completeStaffSetup?.user?.userId) {
        setSuccessIsOpen(true);
      } else {
        const content = "Set password failed!";
        debouncedErrorMessage(content);
        setSuccessIsOpen(false);
      }
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(
            error.graphQLErrors[0]?.extensions?.exception
          );
        }
        debouncedErrorMessage(content);
      }
    },
  });

  const handleContinue = () => {
    if (password.length >= 8) {
      completeStaffSetup({
        variables: {
          input: {
            token,
            newPassword: password,
            //TODO: The following fields is not required by backend but potentially needed in the future, so keep them here for now
            // phoneVerificationCode: 
          },
        },
      });
    } else {
      setPasswordError(true);
    }
  };

  return (
    <Container>
      <Helmet>
        <title>Setup - Rook Hotel PMS</title>
        <meta name="description" content="Setup - Rook Hotel PMS" />
      </Helmet>
      <ContentContainer>
        <img src={Logo} alt="Logo" />
        <div className="brand">
          <span className="rook">ROOK </span>
          <span className="hotel">HOTEL</span>
        </div>
        <div className="title">Setup Password</div>
        <div className="password">
          <Input
            title={"NEW PASSWORD"}
            required
            error={passwordError}
            errorMessage={
              password.length
                ? "Password must contain at least 8 characters."
                : "This field is required."
            }
            placeholder={"Password"}
            onChange={(e) => setPassword(e.target.value)}
            type={passwordHidden ? "password" : "text"}
            additionalstyle={`
              width: 100%;
              margin-top: 24px;
              input {
                font-size: 14px;
                font-weight: 400;
              }
            `}
          />
          {passwordHidden ? (
            <div
              className="passwordLock"
              onClick={() => {
                setPasswordHidden(false);
              }}
            >
              <HiddenIcon />
            </div>
          ) : (
            <div
              className="passwordUnlock"
              onClick={() => {
                setPasswordHidden(true);
              }}
            >
              <VisibleIcon />
            </div>
          )}
        </div>
        <Button
          mainPage
          onClick={handleContinue}
          data-loading={resetPasswordLoading}
          additionalstyle={`
            width: 97px;
            margin-top: 24px;
          `}
        >
          {resetPasswordLoading ? null : "Continue"}
        </Button>
      </ContentContainer>
      <ModalResetPasswordSuccessfully
        isOpen={successIsOpen}
        setClose={() => {
          setSuccessIsOpen(false);
          navigate('/login');
        }}
      />
    </Container>
  );
};

export default SetupPassword;
